import { render, staticRenderFns } from "./InputPTTableCustom.vue?vue&type=template&id=4e7079a9&scoped=true"
import script from "./InputPTTableCustom.vue?vue&type=script&lang=js"
export * from "./InputPTTableCustom.vue?vue&type=script&lang=js"
import style0 from "./InputPTTableCustom.vue?vue&type=style&index=0&id=4e7079a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7079a9",
  null
  
)

export default component.exports